export default __webpack_public_path__ + "static/media/coleFarm.009ea258.jpg";